import { stringify } from 'qs'

export const stringifyQuery = (params) => {
  if (params) {
    return `?${stringify(params)}`
  }
  return ''
}
